/**
 * Expõe o suporte do config/app.php nos templates Vue,
 * lendo os valores compartilhados pelo HandleInertiaRequests.
 *
 * getSupportEmail()         → config app.support_email
 * getDevopsEmail()          → config app.devops_email
 * getSupportPhone()         → config app.support_whats_app, formatado
 * getSupportWhatsApp(true)  → o mesmo número formatado para exibição
 * getSupportWhatsApp(false) → dígitos E.164 sem "+", para links wa.me
 */
export default {
    install(app) {
        app.config.globalProperties.getSupportEmail = function () {
            return this.$page?.props?.supportEmail ?? "";
        };

        app.config.globalProperties.getDevopsEmail = function () {
            return this.$page?.props?.devopsEmail ?? "";
        };

        app.config.globalProperties.getSupportPhone = function () {
            return this.$page?.props?.supportWhatsApp ?? "";
        };

        app.config.globalProperties.getSupportWhatsApp = function (formatted = true) {
            if (formatted) {
                return this.$page?.props?.supportWhatsApp ?? "";
            }

            return this.$page?.props?.supportWhatsAppE164 ?? "";
        };
    },
};
